module.exports = __webpack_public_path__ + "static/media/transformacija.f8b96225.jpg";